/**
 * Function to convert a number to corrency format number (eg 123,000)
 * @param {String} amt the dollar amount
 */

const formatNumberToCurrency = (amt, outOfPocket) => {
    return outOfPocket < 1
        ? amt.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
          })
        : Math.round(amt).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
          });
};

export default formatNumberToCurrency;
